import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "header-label" }
const _hoisted_3 = { class: "loader-div-sm" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "modal-footer footer" }

import VueDragResize from "vue-drag-resize";
import { ElButton, ElScrollbar } from "element-plus";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'PayloadPopup',
  props: {
    size: {},
    fixed: { type: Boolean },
    fixedHeight: { type: Boolean },
    lazyLoad: { type: Boolean },
    moved: { type: Boolean }
  },
  emits: ["close-popup", "updateHeight", "lazyLoad"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const screen = document.getElementById("app");

const parent = document.getElementById("content");

const width = ref(setWidthSize());
const height = ref(setHeightSize());
const x = ref(computeX());
const y = ref(computeY());
const z = ref(900);
const maximized = ref(false);
const counter = ref(0);

const oldX = ref();
const oldY = ref();
const oldWidth = ref();
const oldHeight = ref();

const scrollHeight = computed(() => height.value - 230);

const scrollbar = ref();

const loading = ref(false);
function setWidthSize() {
  switch (props.size) {
    case "sm":
      return parent ? (3 * parent.clientWidth) / 6 : 765;
    case "m":
      return parent ? (4 * parent.clientWidth) / 6 : 1330;
    case "l":
      return parent ? (5 * parent.clientWidth) / 6 : 1750;
    default:
      return parent ? (3 * parent.clientWidth) / 6 : 765;
  }
}

function setHeightSize() {
  switch (props.size) {
    case "sm":
      return parent ? (3 * parent.clientHeight) / 6 : 460;
    case "m":
      return parent ? (4 * parent.clientHeight) / 6 : 710;
    case "l":
      return parent ? (5 * parent.clientHeight) / 6 : 900;
    default:
      return parent ? (3 * parent.clientHeight) / 6 : 460;
  }
}

function triggerLazyLoad(event) {
  if (props.lazyLoad) {
    const mainScreen = document.getElementById("main-screen");
    const distanceToBottom =
      scrollbar.value && mainScreen
        ? event.scrollTop + (height.value - 80) - mainScreen.offsetHeight
        : -1;
    if (distanceToBottom >= 0 && !loading.value) {
      loading.value = true;
      setTimeout(() => {
        emit("lazyLoad");
        loading.value = false;
      }, 1000);
    }
  }
}

function computeX() {
  if (props.moved) {
    return parent.offsetLeft - parent.clientWidth / 2;
  }
  if (screen) {
    return (screen.clientWidth - width.value) / 2;
  }
  return parent ? parent.offsetLeft : 172;
}

function computeY() {
  if (screen) {
    return (screen.clientHeight - height.value) / 2;
  }
  return parent ? parent.offsetTop : 52;
}

watch(
  () => scrollHeight.value,
  () => {
    emit("updateHeight", scrollHeight.value);
  }
);

function maximizeMinimizeWindow() {
  if (maximized.value) {
    width.value = oldWidth.value ? oldWidth.value : setWidthSize();
    height.value = oldHeight.value ? oldHeight.value : setHeightSize();
    maximized.value = false;
    x.value = oldX.value ? oldX.value : parent?.offsetLeft;
    y.value = oldY.value ? oldY.value : parent?.offsetTop;
    z.value -= 1000;
  } else {
    width.value = parent ? parent.clientWidth : setWidthSize();
    height.value = parent ? parent.clientHeight : setHeightSize();
    x.value = parent?.offsetLeft;
    y.value = parent?.offsetTop;
    maximized.value = true;
    z.value += 1000;
  }
  counter.value++;
}

function onActivated() {
  z.value += 100;
}

function onDeactivated() {
  z.value -= 100;
}

function positionChange(obj) {
  if (!maximized.value) {
    oldWidth.value = obj.width;
    oldHeight.value = obj.height;
    oldX.value = obj.left;
    oldY.value = obj.top;
    width.value = obj.width;
    height.value = obj.height;
  }
  const mainScreen = document.getElementById("main-screen");
  if (mainScreen) {
    if (
      mainScreen.offsetHeight <= height.value - 87 &&
      !loading.value &&
      props.lazyLoad
    ) {
      loading.value = true;
      setTimeout(() => {
        emit("lazyLoad");
        loading.value = false;
      }, 1000);
    }
  }
}

function mousedown(e) {
  e.stopPropagation();
}

function mouseup(e) {
  e.preventDefault();
}

function updateWindow() {
  if (maximized.value) {
    width.value = parent?.clientWidth || 1500;
    height.value = parent?.clientHeight || 1000;
    x.value = parent?.offsetLeft;
    y.value = parent?.offsetTop;
    counter.value++;
  } else if (
    !maximized.value &&
    (parent.clientWidth < width.value || parent.clientHeight < height.value)
  ) {
    maximizeMinimizeWindow();
  }
}

onMounted(() => {
  window.addEventListener("resize", updateWindow);
});
onUnmounted(() => {
  window.removeEventListener("resize", updateWindow);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_unref(VueDragResize), {
    isActive: false,
    key: counter.value,
    w: width.value,
    h: height.value,
    z: z.value,
    x: x.value,
    y: y.value,
    minw: 660,
    minh: 460,
    stickSize: 4,
    style: {"position":"fixed"},
    onResizestop: positionChange,
    onResizing: positionChange,
    onDragging: positionChange,
    onDragstop: positionChange,
    onActivated: onActivated,
    onDeactivated: onDeactivated
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "header background-fb",
          onDblclick: maximizeMinimizeWindow
        }, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "header-label", {}, () => [
              _createTextVNode(" Payload ")
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(ElButton), {
              type: "text",
              id: "maximize-popup",
              onClick: maximizeMinimizeWindow
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  style: {"color":"#5022a6"},
                  icon: maximized.value ? 'window-maximize' : 'window-restore'
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElButton), {
              type: "text",
              id: "close-popup",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close-popup')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  style: {"color":"#5022a6"},
                  icon: "times"
                })
              ]),
              _: 1
            })
          ])
        ], 32),
        _createElementVNode("div", {
          onMousedown: mousedown,
          onMouseup: mouseup
        }, [
          _createVNode(_unref(ElScrollbar), {
            "max-height": (height.value - 87).toString() + 'px',
            onScroll: triggerLazyLoad,
            ref_key: "scrollbar",
            ref: scrollbar,
            onMouseup: mouseup
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                id: "main-screen",
                class: "modal-body content-body background-fb",
                style: _normalizeStyle([{"margin":"12px"}, 
              _ctx.fixedHeight
                ? { height: `${(height.value - 87).toString()}px` }
                : { minHeight: `${(height.value - 87).toString()}px` }
            ])
              }, [
                _renderSlot(_ctx.$slots, "main")
              ], 4)
            ]),
            _: 3
          }, 8, ["max-height"]),
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
              alt: "Loading...",
              class: "loader-logo-40"
            }, null, 8, _hoisted_4)
          ], 512), [
            [_vShow, loading.value && _ctx.lazyLoad]
          ])
        ], 32),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer")
        ])
      ])
    ]),
    _: 3
  }, 8, ["w", "h", "z", "x", "y"]))
}
}

})